import { render, staticRenderFns } from "./UISimpleProfileCard.vue?vue&type=template&id=e0bc42c8"
import script from "./UISimpleProfileCard.vue?vue&type=script&lang=js"
export * from "./UISimpleProfileCard.vue?vue&type=script&lang=js"
import style0 from "./UISimpleProfileCard.vue?vue&type=style&index=0&id=e0bc42c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default})
